import { render, staticRenderFns } from "./address.vue?vue&type=template&id=5a453efb&scoped=true&"
import script from "./address.vue?vue&type=script&lang=ts&"
export * from "./address.vue?vue&type=script&lang=ts&"
import style0 from "./address.vue?vue&type=style&index=0&id=5a453efb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a453efb",
  null
  
)

export default component.exports